<template>
	<div v-if="hasMounted">
		<h4 class="mb-3">{{ WidgetName(type) }}</h4>
		<o-field label="Title" message="The title that will display on this card.">
			<o-input v-model="model.title" type="text"></o-input>
		</o-field>
		<o-field v-if="contentType === ContentType.RichText" label="Content">
			<ckeditor
				:editor="editor.type"
				v-model="model.text"
				:config="editor.config"
				:disabled="$store.getters.isDragging"></ckeditor>
		</o-field>
		<div class="mt-2 columns" v-if="contentType">
			<o-field
				label="Column Width"
				class="column is-narrow"
				message="The column span for this field.">
				<o-select v-model="model.width">
					<option :value="null">Auto</option>
					<!-- <option :value="1">8%&nbsp;(1/12)</option>
					<option :value="2">16%&nbsp;(1/6)</option>
					<option :value="3">25%&nbsp;(1/4)</option>
					<option :value="4">33%&nbsp;(1/3)</option>
					<option :value="5">42%&nbsp;(5/12)</option> -->
					<option :value="6">50%&nbsp;(1/2)</option>
					<!-- <option :value="7">58%&nbsp;(7/12)</option>
					<option :value="8">66%&nbsp;(2/3)</option>
					<option :value="9">75%&nbsp;(3/4)</option>
					<option :value="10">83%&nbsp;(5/6)</option>
					<option :value="11">92%&nbsp;(11/12)</option> -->
					<option :value="12">100%</option>
				</o-select>
			</o-field>
			<o-field
				label="Min Width"
				class="column is-narrow"
				message="The minimum width in REMs."
				v-if="false">
				<o-input v-model="model.minWidth" type="number" step="any"></o-input>
			</o-field>
		</div>
		<div class="mt-2" v-if="type === WidgetType.Calendar">
			<o-field label="View">
				<o-select v-model="attrs.view" placeholder="Calendar">
					<option value="calendar">Calendar</option>
					<option value="list">List</option>
				</o-select>
			</o-field>
			<o-field label="Limit end date (in months)">
				<o-input type="number" v-model="attrs.limitMonths" placeholder="6" min="1" max="24" step="1"></o-input>
			</o-field>
			<o-field label="Limit events">
				<o-input type="number" v-model="attrs.limitEvents" placeholder="10" min="1" max="100" step="1"></o-input>
			</o-field>
		</div>
		<div class="mt-2" v-if="contentType === ContentType.PagePromotion">
			<o-field label="To page name">
				<o-input v-model="model.to" type="text"></o-input>
			</o-field>
		</div>
		<div class="mt-2" v-if="type == WidgetType.TopPartners">
			<o-radio v-model="noFilter" :name="section.UUID" native-value="true">Use page filter</o-radio>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="false">
				Override filter
			</o-radio>
			<o-field label="Filter" v-show="noFilter == 'false'">
				<search-filter v-model="attrs.json" type="users"></search-filter>
			</o-field>
		</div>
		<div class="mt-2" v-if="type == WidgetType.TopOffices">
			<o-radio v-model="noFilter" :name="section.UUID" native-value="true">Use page filter</o-radio>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="false">
				Override filter
			</o-radio>
			<o-field label="Filter" v-show="noFilter == 'false'">
				<search-filter v-model="attrs.json" type="users"></search-filter>
			</o-field>
		</div>
		<div class="mt-2" v-if="type == WidgetType.TopPracticeGroups">
			<o-radio v-model="noFilter" :name="section.UUID" native-value="true">Use page filter</o-radio>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="false">
				Override filter
			</o-radio>
			<o-field label="Filter" v-show="noFilter == 'false'">
				<search-filter v-model="attrs.json" type="users"></search-filter>
			</o-field>
		</div>
		<div class="mt-2" v-if="type == WidgetType.UserIntro">
			<o-field label="User">
				<autocomplete v-model="attrs.userId" type="user"></autocomplete>
			</o-field>
		</div>
		<div class="mt-2" v-if="type == WidgetType.NewPartners">
			<o-field label="AD Group">
				<o-input v-model="attrs.adgroup"></o-input>
			</o-field>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="true">Use page filter</o-radio>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="false">
				Override filter
			</o-radio>
			<o-field label="Filter" v-show="noFilter == 'false'">
				<search-filter v-model="attrs.json" type="users"></search-filter>
			</o-field>
			<div class="tile is-horizontal mb-5">
				<div class="tile">
					<o-field label="Show Full Report" message="Includes a 'full report' button">
						<o-switch v-model="attrs.fullReport"></o-switch>
					</o-field>
				</div>
				<div class="tile">
					<o-field label="Rename Full Report">
						<o-input v-model="attrs.fullReportBtnText" placeholder="Full report"></o-input>
					</o-field>
				</div>
			</div>
		</div>
		<div class="mt-2" v-if="type == WidgetType.RecentTeamingWin">
			<o-radio v-model="noFilter" :name="section.UUID" native-value="true">Use page filter</o-radio>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="false">
				Override filter
			</o-radio>
			<o-field label="Filter" v-show="noFilter == 'false'">
				<search-filter v-model="attrs.json" type="assignments"></search-filter>
			</o-field>
		</div>
		<div class="mt-2" v-if="type == WidgetType.RecentAssignments">
			<o-field label="Limit results">
				<o-select v-model="attrs.take" placeholder="All results">
					<option value="0">All results</option>
					<option value="5">5</option>
					<option value="10">10</option>
				</o-select>
			</o-field>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="true">Use page filter</o-radio>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="false">
				Override filter
			</o-radio>
			<o-field label="Filter" v-show="noFilter == 'false'">
				<search-filter v-model="attrs.json" type="assignments"></search-filter>
			</o-field>
		</div>
		<div class="mt-2" v-if="type == WidgetType.Dashboard">
			<o-radio v-model="noFilter" :name="section.UUID" native-value="true">Use page filter</o-radio>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="false">
				Override filter
			</o-radio>
			<o-field label="Filter" v-show="noFilter == 'false'">
				<search-filter v-model="attrs.json" type="financial"></search-filter>
			</o-field>
		</div>
		<div class="mt-2" v-if="type == WidgetType.DashboardPromo">
			<o-radio v-model="noFilter" :name="section.UUID" native-value="true">Use page filter</o-radio>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="false">
				Override filter
			</o-radio>
			<o-field label="Filter" v-show="noFilter == 'false'">
				<search-filter v-model="attrs.json" type="financial"></search-filter>
			</o-field>
		</div>
		<div class="mt-2" v-if="type == WidgetType.RecentCompanies">
			<o-radio v-model="noFilter" :name="section.UUID" native-value="true">Use page filter</o-radio>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="false">
				Override filter
			</o-radio>
			<o-field label="Limit results">
				<o-select v-model="attrs.take">
					<option value="0">All results</option>
					<option value="5">5</option>
					<option value="10">10</option>
				</o-select>
			</o-field>
			<o-field label="Filter" v-show="noFilter == 'false'">
				<search-filter v-model="attrs.json" type="companies"></search-filter>
			</o-field>
		</div>
		<div class="mt-2" v-if="type == WidgetType.MemberList">
			<o-field label="AD Group">
				<o-input v-model="attrs.adgroup"></o-input>
			</o-field>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="true">Use page filter</o-radio>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="false">
				Override filter
			</o-radio>
			<o-field label="Filter" v-show="noFilter == 'false'">
				<search-filter v-model="attrs.json" type="users"></search-filter>
			</o-field>
			<div class="tile is-horizontal mb-5">
				<div class="tile">
					<o-field label="Sort by">
						<o-select v-model="attrs.sort" placeholder="Last name">
							<option value="lastName">Last name</option>
							<option value="joinDate">Join date</option>
							<option value="hireDate">Hire date</option>
							<option value="roleChanged">Hire / Role change</option>
						</o-select>
					</o-field>
				</div>
				<div class="tile">
					<o-field label="Sort direction">
						<o-select v-model="attrs.sortDirection" placeholder="Ascending">
							<option value="ASC">Ascending</option>
							<option value="DESC">Descending</option>
						</o-select>
					</o-field>
				</div>
			</div>
			<div class="tile is-horizontal mb-5">
				<div class="tile">
					<o-field label="Show Full Report" message="Includes a 'full report' button">
						<o-switch v-model="attrs.fullReport"></o-switch>
					</o-field>
				</div>
				<div class="tile">
					<o-field label="Rename Full Report">
						<o-input v-model="attrs.fullReportBtnText" placeholder="Full report"></o-input>
					</o-field>
				</div>
			</div>
		</div>
		<div class="mt-2" v-if="type == WidgetType.MemberListPromo">
			<o-field label="AD Group">
				<o-input v-model="attrs.adgroup"></o-input>
			</o-field>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="true">Use page filter</o-radio>
			<o-radio v-model="noFilter" :name="section.UUID" native-value="false">
				Override filter
			</o-radio>
			<o-field label="Limit results">
				<o-input type="number" v-model="attrs.take" placeholder="8"></o-input>
			</o-field>
			<o-field label="Filter" v-show="noFilter == 'false'">
				<search-filter v-model="attrs.json" type="users"></search-filter>
			</o-field>
			<div class="tile is-horizontal">
				<div class="tile">
					<o-field label="Sort by">
						<o-select v-model="attrs.sort" placeholder="Last name">
							<option value="lastName">Last name</option>
							<option value="joinDate">Join date</option>
							<option value="hireDate">Hire date</option>
							<option value="roleChanged">Hire / Role change</option>
						</o-select>
					</o-field>
				</div>
				<div class="tile">
					<o-field label="Sort direction">
						<o-select v-model="attrs.sortDirection" placeholder="Ascending">
							<option value="ASC">Ascending</option>
							<option value="DESC">Descending</option>
						</o-select>
					</o-field>
				</div>
			</div>
			<div class="tile is-horizontal mb-5">
				<div class="tile">
					<o-field label="Show Full Report" message="Includes a 'full report' button">
						<o-switch v-model="attrs.fullReport"></o-switch>
					</o-field>
				</div>
				<div class="tile">
					<o-field label="Rename Full Report">
						<o-input v-model="attrs.fullReportBtnText" placeholder="Full report"></o-input>
					</o-field>
				</div>
			</div>
		</div>
		<div class="mt-2" v-if="type == WidgetType.Promos">
			<edit-promo v-model="attrs" :pageId="parent"></edit-promo>
		</div>
		<div class="mt-2" v-if="type == WidgetType.BoxFiles">
			<o-field label="Current folder" v-if="attrs.folder && attrs.folder.path">
				<span>{{ attrs.folder.path }}</span>
			</o-field>
			<o-field label="Select box folder">
				<box-file-tree
					v-model="attrs.folder"
					:path="attrs.path || ''"
					:options="{ sort: 'Name', direction: 0, limit: 1000 }"></box-file-tree>
			</o-field>
			<div>
				<o-field label="Sort by">
					<o-select v-model="attrs.sort" placeholder="Name">
						<option value="name">Name</option>
						<option value="created_at">Created At</option>
						<option value="modified_at">Modified At</option>
						<option value="size">Size</option>
					</o-select>
				</o-field>
				<o-field label="Sort direction">
					<o-switch v-model="attrs.direction">{{ !attrs.direction ? "ASC" : "DESC" }}</o-switch>
				</o-field>
			</div>
			<o-field label="Display">
				<o-radio v-model="attrs.display" name="display" native-value="Promo">&nbsp; Promo</o-radio>
				<o-radio v-model="attrs.display" name="display" native-value="Table">&nbsp; Table</o-radio>
			</o-field>
			<o-field label="Limit to">
				<o-input type="number" v-model="attrs.limit" placeholder="1000"></o-input>
			</o-field>
		</div>
		<div class="mt-2" v-if="type == WidgetType.Viewer">
			<o-radio v-model="attrs.viewerRbtn" :name="section.UUID" native-value="path">
				Use relative path
			</o-radio>
			<o-radio v-model="attrs.viewerRbtn" :name="section.UUID" native-value="embed">
				Use an embedded resource
			</o-radio>
			<o-field
				label="Uri"
				message="The relative path for v1 Boyden."
				v-if="attrs.viewerRbtn == 'path'">
				<o-input v-model="attrs.uri" placeholder="dashboard"></o-input>
			</o-field>
			<o-field
				label="Code snippet"
				message="Paste the embed code snippet."
				v-if="attrs.viewerRbtn == 'embed'">
				<o-input v-model="attrs.embed" type="textarea" placeholder="Paste html content.."></o-input>
			</o-field>
		</div>
		<div class="mt-2" v-if="type == WidgetType.QuickLinks">
			<quick-links v-model="attrs.items" edit></quick-links>
		</div>
	</div>
</template>
<script>
	import { getCurrentInstance, ref, computed, watch, onMounted, inject } from "vue";
	import { Editors } from "@/services/utils/ckeditor";
	import ContentType from "@/services/utils/contentTypes";
	import WidgetType from "@/services/utils/widgetTypes";
	import WidgetName from "@/services/utils/widgetNames";
	import { searchFilter, autocomplete } from "@/components/webComponents";
	import { boxFileTree, quickLinks } from "@/components/webComponents/widget";
	import { promos } from "@/components/webComponents/editPageWidget";

	export default {
		components: {
			searchFilter,
			autocomplete,
			boxFileTree,
			editPromo: promos,
			quickLinks
		},
		props: {
			parent: {
				type: [String],
				default: undefined
			},
			contentType: {
				type: [String],
				default: undefined
			},
			type: {
				type: [String],
				default: undefined
			},
			section: {
				type: Object,
				default: () => {
					return {};
				}
			},
			width: {
				type: [Number],
				default: undefined
			},
			minWidth: {
				type: [Number],
				default: undefined
			},
			title: {
				type: [String],
				default: ""
			},
			text: {
				type: [String],
				default: ""
			}
		},
		emits: ["update"],
		setup(props, context) {
			const $json = inject("$json");
			const hasMounted = ref(false);
			const saving = ref(false);
			const deleting = ref(false);
			const model = ref({
				width: props.width,
				title: props.title,
				text: props.text,
				to: props.section.ToVueRouterName,
				attrs: props.section.Attributes || []
			});
			const attrs = ref(
				model.value.attrs.reduce((a, c) => {
					a[c.Name] = $json.isJSON(c.Value) ? JSON.parse(c.Value) : c.Value;
					return a;
				}, {})
			);
			const noFilter = ref(model.value.attrs.some((x) => x.Name == "json") ? "false" : "true");

			const editor = ref(Editors.Default);

			const topOfficesOptions = ref([
				{
					Id: "CountryId",
					Text: "Country",
					options: "/api/v2/country/filter"
				}
			]);
			const topPracticeGroupsOptions = ref([
				{
					Id: "FunctionId",
					Text: "Function",
					options: "/api/v2/function/filter"
				}
			]);

			const SetAttributes = () => {
				for (const prop in attrs.value) {
					if (noFilter.value == "true") {
						//Skip filters
						if (prop == "json") {
							model.value.attrs = model.value.attrs.filter((x) => x.Name !== prop);
							continue;
						}
					}

					if (prop == "json") {
						const json = model.value.attrs.find((x) => x.Name == "json");
						if (json) {
							json.Value = JSON.stringify(attrs.value.json);
						} else model.value.attrs.push({ Name: "json", Value: JSON.stringify(attrs.value.json) });
					} else {
						if (typeof attrs.value[prop] !== "string") {
							const json = model.value.attrs.find((x) => x.Name == prop);
							if (json) {
								json.Value = JSON.stringify(attrs.value[prop]);
							} else model.value.attrs.push({ Name: prop, Value: JSON.stringify(attrs.value[prop]) });
						} else {
							const key = model.value.attrs.find((x) => x.Name == prop);
							if (key) {
								key.Value = attrs.value[prop];
							} else model.value.attrs.push({ Name: prop, Value: attrs.value[prop] });
						}
					}
				}
			};

			const UpdateModel = (n) => {
				const result = n || model.value;
				context.emit("update", result);
			};

			watch(
				() => model.value,
				(n, o) => {
					if (n !== undefined) {
						//context.emit("update:modelValue", n);
						UpdateModel(n);
					}
				},
				{ deep: true }
			);

			watch(
				() => attrs.value,
				(n, o) => {
					SetAttributes();
				},
				{ deep: true }
			);

			watch(
				() => noFilter.value,
				(n, o) => {
					SetAttributes();
				}
			);

			onMounted(() => {
				// if (props.text) {
				// 	model.value.text = props.text;
				// }
				// if (props.width) {
				// 	model.value.width = props.width;
				// }
				// if (props.minWidth) {
				// 	model.value.minWidth = props.minWidth;
				// }
				// if (props.title) {
				// 	model.value.title = props.title;
				// }
				hasMounted.value = true;
			});

			return {
				WidgetType,
				WidgetName,
				hasMounted,
				model,
				attrs,
				noFilter,
				saving,
				deleting,
				editor,
				topOfficesOptions,
				topPracticeGroupsOptions,
				ContentType
			};
		}
	};
</script>
